function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  d: "M23.584 29.521v-4.153a2.178 2.178 0 0 1-1.265-3.396l2.927-4.048a2.5 2.5 0 0 1 4.036-.021l1.658 2.243c.37-1.338.56-2.729.56-4.146C31.5 7.44 24.56.5 16 .5 7.44.5.5 7.44.5 16c0 8.56 6.94 15.5 15.5 15.5 2.695 0 5.288-.688 7.584-1.979z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8C54",
  d: "M10 19h11c1.226 0 2.324.552 3.058 1.42l-1.334 1.845a1.678 1.678 0 0 0 1.36 2.661v3.778c-2.641 1.544-5.502 2.31-8.582 2.296-3.313-.015-6.372-1.198-9.18-3.55L6 27.174V23a4 4 0 0 1 3.8-3.995L10 19h11zm6-12a5 5 0 1 1 0 10 5 5 0 0 1 0-10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#873D00",
  d: "M16.002 22.998c2.504 0 4.584-1.715 4.998-3.972 0-.025-10-.028-10-.025.403 2.269 2.49 3.997 5.002 3.997z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D01E29",
  d: "M24.323 23.44H25.5V31a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-7.56h1.195c.234 0 .381-.208.264-.373l-2.73-3.945a.319.319 0 0 0-.257-.122.313.313 0 0 0-.25.122l-2.7 3.945c-.08.165.066.374.301.374z"
}));

var SvgImportacaoCidadao = function SvgImportacaoCidadao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImportacaoCidadao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/importacao-cidadao.bdc72523.svg";
export { ForwardRef as ReactComponent };